import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "user-button" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { key: 0 }

import { computed, ref, watch } from 'vue';
import { VueCookieNext } from 'vue-cookie-next';
import Menu from 'primevue/menu';
import { PersonStores, useAuthStore, useCalendarStore, useTenantStore } from '@/store';
import UserCreate from '@/views/Users/components/UserCreate/UserCreate.vue';
import { can } from '@/composables';
import { PERMISSIONS } from '@/enum';
import router from '@/router';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserProfileHeader',
  setup(__props) {

const menu = ref<Menu>();
const displayEditProfileModal = ref(false);

const authStore = useAuthStore();
const calendarStore = useCalendarStore();
const tenantStore = useTenantStore();
const profileStore = PersonStores.useUserProfileStore();

const isAdmin = computed<boolean>(() => can([PERMISSIONS.VIEW_ADMINISTRATION]));

const authItems: Record<string, string | (() => void)>[] = [
  {
    label: 'Profile',
    icon: 'm-icon person',
    command: () => handleProfile(),
  },
  {
    label: 'Sign Out',
    icon: 'm-icon logout',
    command: () => logout(),
  },
];

const unAuthItems: Record<string, string>[] = [
  {
    label: 'Sign In',
    icon: 'm-icon login',
    url: '/account/login',
  },
];

const publicItems: Record<string, string>[] = [
  {
    label: 'Privacy Policy',
    url: '/legal/privacy-policy',
    class: 'sub-item sub-item-border',
  },
  {
    label: 'Terms of Service',
    url: '/legal/terms-of-service',
    class: 'sub-item',
  },
];

const items = computed(() => [
  {
    label: authStore.loggedIn ? displayName.value : 'My account',
    items: authStore.loggedIn ? authItems : unAuthItems,
  },
  ...publicItems,
]);

watch(
  () => authStore.loggedIn,
  () => {
    if (!authStore.loggedIn) {
      calendarStore.resetEvents();
    }
  },
);

const toggleUserMenu = (toggle: Event) => menu.value?.toggle(toggle);

const firstName = computed(() => authStore.user?.first_name);

const lastName = computed(() => authStore.user?.last_name);

const initials = computed(() => `${firstName.value?.at(0)}${lastName.value?.at(0)}`.toUpperCase());

const displayName = computed(() => `${firstName.value} ${lastName.value}`);

const logout = async () => {
  const access_token_tenant = VueCookieNext.getCookie('access_token_tenant');

  if (authStore.isImpersonating) await authStore.leaveImpersonate(true);

  if (access_token_tenant) {
    const tenant = access_token_tenant.guest_tenant;
    tenantStore.leaveTenant(tenant.id);
  }

  await authStore
    .logout()
    .then(() => {
      authStore.resetAuthStore();
      tenantStore.resetTenantStore();
    })
    .catch((er) => {
      console.error(er);
    });
};

const handleProfile = async () => {
  if (!isAdmin.value) {
    await router.push('/profile');
  }
  await profileStore.getAuthUserProfile();
  displayEditProfileModal.value = true;
};

const onEditProfileToggle = () => {
  displayEditProfileModal.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "user-profile-container",
      onClick: toggleUserMenu
    }, [
      _createElementVNode("span", _hoisted_1, [
        (_unref(authStore).loggedIn)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "text-white",
              textContent: _toDisplayString(initials.value)
            }, null, 8, _hoisted_2))
          : (_openBlock(), _createBlock(_component_Icon, {
              key: 1,
              name: "account_circle",
              class: "text-white"
            }))
      ]),
      _createVNode(_unref(Menu), {
        ref_key: "menu",
        ref: menu,
        model: items.value,
        popup: true
      }, null, 8, ["model"])
    ]),
    (_unref(authStore).loggedIn && isAdmin.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (displayEditProfileModal.value)
            ? (_openBlock(), _createBlock(UserCreate, {
                key: 0,
                id: _unref(profileStore).id,
                "person-type-acronym": _unref(authStore).acronymType,
                "is-edit": true,
                "is-admin": true,
                header: `Edit Profile`,
                "save-button-text": `Save`,
                "is-profile": true,
                onCancel: onEditProfileToggle,
                onEdit: onEditProfileToggle
              }, null, 8, ["id", "person-type-acronym"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})